<template>
  <div class="text-center p-5 `\${accountType}`">
    <h1>Complete Your Profile</h1>
  </div>
</template>
<script>
export default {
  props: {
    accountType: {
      type: String,
      default: "straight",
    },
  },
};
</script>
